/* BackupsPreviewRenderer.js */

"use strict";
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const InputTextControl = require("@gluenetworks/steve_ui_core").Control.Textfield.InputText;
const InputCheckboxControl = require("@gluenetworks/steve_ui_core").Control.Boolean.InputCheckbox;
const DateControl = require("@gluenetworks/steve_ui_core").Control.Timestamp.DateTimePicker;
require("@progress/kendo-ui/js/kendo.daterangepicker");
const formatters = require("./formatters/index");
const BackupEditor = require("./cellEditors/BackupEditor");

/* global Slick */

class BackupPreviewRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("backup-preview-gl"); //TODO Setup the root Element
        this._rootElem.component = this._model;

        this._anchorForTooltip = document.createElement("u");
        this._anchorForTooltip.innerText = "supported OS";

        this._nameRegexInputEl = new InputTextControl({
            darkTheme: true,
            placeholder: "Name (regex)",
        });

        this._setDefaultCaptureCheckbox = new InputCheckboxControl({
            label: "Set new snapshot as the default configuration",
            labelShown: true,
            value: false,
            darkTheme: true,
            disabled: false,
        });

        this._restoreWithMismatchCheckbox = new InputCheckboxControl({
            label: "Restore with OS or serial mismatches",
            labelShown: true,
            value: false,
            darkTheme: true,
            disabled: false,
        });

        this._startDateControl = new DateControl({
            label: "Between",
            labelShown: true,
            value: "",
            darkTheme: true,
            disabled: false,
        });

        this._endDateControl = new DateControl({
            label: "And",
            labelShown: true,
            value: "",
            darkTheme: true,
            disabled: false,
        });

        this._cancelButton = new ButtonControl({
            label: "Cancel",
            darkTheme: true,
        });

        this._confirmButton = new ButtonControl({
            label: "Start Restore",
            darkTheme: true,
            active: true,
        });

        this._backButton = new ButtonControl({
            label: "Back",
            darkTheme: true,
        });

        this._scheduleButton = new ButtonControl({
            label: "Schedule Restore",
            darkTheme: true,
        });

        this._titleComponent = document.createElement("h2");
        this._titleComponent.innerText = this._model.titleText;

        this._messageBox = this._createMessageBox();

        this._countContainer = document.createElement("div");
        this._countContainer.classList.add("count-container");
        this._addCount();

        this._buttonContainer = document.createElement("button-container");

        this._footer = document.createElement("div");
        this._footer.classList.add("footer-container");
        this._footer.appendChild(this._countContainer);
        this._footer.appendChild(this._buttonContainer);

        this._backupsTableWrapper = document.createElement("div");
        this._backupsTableWrapper.classList.add("backups-table-wrapper");

        this._typeContainer = document.createElement("div");
        this._typeContainer.classList.add("type-container");

        this._pickerControl = {};
        this._dateTimePickerComp = {};
        this._pickerId = {};
        this._checkExist = {};

        // Slick

        this._slickTableContainer = document.createElement("backups-table");
        this._slickTable = undefined;

        this._columns = [
            {
                id: "type",
                width: 45,
                name: "Type",
                field: "type",
                toolTip: "Type",
                formatter: formatters.typeFormatter,
                cssClass: "centered",
            },
            {
                id: "name",
                width: 200,
                name: "Name",
                field: "name",
                toolTip: "Name",
                editable: false,
            },
            {
                id: "ipaddress",
                width: 180,
                name: "IP Address",
                field: "ipAddress",
                toolTip: "IP Address",
            },
            {
                id: "vendor",
                width: 150,
                name: "Vendor",
                field: "vendor",
                toolTip: "Vendor",
            },
            {
                id: "backup",
                width: 294,
                name: "Backup",
                field: "backup",
                toolTip: "Backup",
                editor: BackupEditor,
            },
        ];

        this._tableOptions = {
            editable: true,
            enableTextSelectionOnCells: true,
            enableCellNavigation: true,
            enableAsyncPostRender: false,
            forceFitColumns: true,
            autoHeight: true,
            autoEdit: false,
            resizable: false,
            rowHeight: 30,
            enableColumnReorder: false,
        };

        this._fitTableSize = this._fitTableSize.bind(this);
        // this._fitTableSize = _.debounce(this._fitTableSize, 200);

        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */

    /********************************************/
    _registerListeners() {
        this._confirmButton.on(
            "UserClick",
            (this._onConfirmButtonClick = this._onConfirmButtonClick.bind(this))
        );
        this._scheduleButton.on(
            "UserClick",
            (this._onScheduleButtonClick = this._onScheduleButtonClick.bind(this))
        );
        this._cancelButton.on(
            "UserClick",
            (this._onCancelButtonClick = this._onCancelButtonClick.bind(this))
        );
        this._backButton.on(
            "UserClick",
            (this._onBackButtonClick = this._onBackButtonClick.bind(this))
        );
    }

    _unregisterListeners() {
        this._confirmButton.removeAllListeners("UserClick");
        this._cancelButton.removeAllListeners("UserClick");
    }

    _registerSlickListeners() {
        if (this._slickTable) {
            window.addEventListener("resize", this._fitTableSize);
            this._slickTable.onCellChange.subscribe(this._onCellChangeAction);
            this._slickTable.onBeforeEditCell.subscribe(this._onBeforeEditCell);
            this._slickDataVIew.onRowCountChanged.subscribe(this._onRowCountChange);
            this._slickDataVIew.onRowsChanged.subscribe(this._onRowsChanged);
        }
    }
    _unregisterSlickListeners() {
        if (this._slickTable) {
            this._slickTable.onCellChange.unsubscribe(this._onCellChangeAction);
            this._slickTable.onBeforeEditCell.subscribe(this._onBeforeEditCell);
            this._slickDataVIew.onRowCountChanged.unsubscribe(this._onRowCountChange);
            this._slickDataVIew.onRowsChanged.unsubscribe(this._onRowsChanged);
            window.removeEventListener("resize", this._fitTableSize);
        }
    }

    _checkForImpliedConfirm(event) {
        if (event.keyCode === 13) {
            // this._callStartCapture();
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */

    /*******************************************/
    shutdown() {
        this._unregisterListeners();
        this._unregisterSlickListeners();
        if (this._slickTable) {
            this._slickTable.destroy();
        }
        let promArr = [
            this._confirmButton.shutdown(),
            this._cancelButton.shutdown(),
            this._backButton.shutdown(),
            this._scheduleButton.shutdown(),
        ];

        if (this._pickerControl["start"]) {
            promArr.push(this._pickerControl["start"].destroy());
        }

        if (this._pickerControl["end"]) {
            promArr.push(this._pickerControl["end"].destroy());
        }

        return Promise.all(promArr).then(
            () => {
                this._confirmButton = undefined;
                this._cancelButton = undefined;
                this._buttonContainer.remove();
                this._buttonContainer = undefined;
                this._titleComponent.remove();
                this._titleComponent = undefined;
                this._typeContainer.remove();
                this._typeContainer = undefined;
                this._messageBox.remove();
                this._messageBox = undefined;
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
            },
            (err) => {
                this._model.logger.warn(err, "CreateQuestionRenderer.shutdown() error");
            }
        );
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return new Promise((resolve /*,reject*/) => {
            if (!this._rootElem.hasChildNodes()) {
                const listOfSUpportedOs = this._createList(this.model._supportedOsList);
                this._anchorForTooltip.setAttribute("title", listOfSUpportedOs);
                this._rootElem.appendChild(this._titleComponent);
                // this._rootElem.appendChild(this._messageBox);
                this._rootElem.appendChild(this._backupsTableWrapper);
                this._backupsTableWrapper.appendChild(this._slickTableContainer);
                this._rootElem.appendChild(this._footer);
                this._buttonContainer.appendChild(this._backButton.renderer.rootElement);
                this._buttonContainer.appendChild(this._cancelButton.renderer.rootElement);
                this._buttonContainer.appendChild(this._scheduleButton.renderer.rootElement);
                this._buttonContainer.appendChild(this._confirmButton.renderer.rootElement);

                this._slickDataVIew = new Slick.Data.DataView();
                this._slickDataVIew.setItems(this._model._generateSlickData());
                setTimeout(() => {
                    this._slickTable = new Slick.Grid(
                        this._slickTableContainer,
                        this._slickDataVIew,
                        this._columns,
                        this._tableOptions
                    );
                    this._slickTable.setSelectionModel(new Slick.RowSelectionModel());
                    // this._slickTable.render();
                    this._registerSlickListeners();
                    // this._fitTableSize();
                }, 400);
            }
            resolve();
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/

    // TODO Private Render Methods here

    _createMessageBox() {
        const messageStart = document.createElement("p");
        messageStart.innerHTML = `Only devices running a`;
        const messageEnd = document.createElement("p");
        messageEnd.innerHTML = `will be restored.`;
        const messageFull = document.createElement("div");
        messageFull.classList.add("supported-os-msg-container");
        messageFull.appendChild(messageStart);
        messageFull.appendChild(this._anchorForTooltip);
        messageFull.appendChild(messageEnd);

        return messageFull;
    }

    _createList(array) {
        const uniqueSet = new Set(array);
        const listItems = [...uniqueSet].map((item) => item || "Empty OS");
        return listItems.join("\n");
    }
    _addCount() {
        let message = "",
            isWarning = false;
        const pluralSuffix = this._model._supportedDevices.length > 1 ? "s" : "";
        if (this._model._devicesWithNoBackup && this._model._devicesWithNoBackup.length > 0) {
            isWarning = true;
            message += `<base-icon-gl data-icon="common.warning"></base-icon-gl> ${this._model._devicesWithNoBackup.length} out of ${this._model._supportedDevices.length} supported device${pluralSuffix} have no backups`;
        } else {
            message += `${this._model._supportedDevices.length} supported device${pluralSuffix}`;
        }

        this._countContainer.innerHTML = message;
        if (isWarning) {
            this._countContainer.classList.add("warning");
        }
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    getSelectedBackups() {
        const data = this._slickDataVIew.getItems();
        const selectedBackups = data.reduce((acc, item) => {
            acc[item.id] = item.backupId;
            return acc;
        }, {});
        return selectedBackups;
    }

    _onCancelButtonClick() {
        this.model.cancelAction();
    }

    _onConfirmButtonClick() {
        // return selected data to action
        const selectedBackups = this.getSelectedBackups();
        this._model.resolve({
            action: "restore",
            selectedBackups,
        });
    }

    _onScheduleButtonClick() {
        const selectedBackups = this.getSelectedBackups();
        this._model.resolve({
            action: "schedule",
            selectedBackups,
        });
    }

    _onBackButtonClick() {
        const selectedBackups = this.getSelectedBackups();
        this._model.resolve({
            action: "gotoSelection",
            selectedBackups,
        });
    }

    _onCellChangeAction() {
        console.log("cell change");
    }

    _onRowCountChange(/*event, {previous, current}*/) {
        this._slickTable.invalidateAllRows();
        this._slickTable.resizeCanvas();
        // this._toggleNoDataPlaceholder(!current);
    }

    _onRowsChanged() {
        // this._setActionButtonsAvailability();
    }

    _onBeforeEditCell(e, {item /* column, row, cell, grid*/}) {
        if (!item.backupId) {
            return false;
        }
        return true;
    }

    _fitTableSize() {
        if (this._slickTable) {
            this._slickTable.resizeCanvas();
        }
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */

    /*******************************************/

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = BackupPreviewRenderer;
